import React from "react"
import styled, { css } from "styled-components"

import ButtonLink from "../../ButtonLink"

import IoAnimator from "../../IoAnimator"

import Bullet from "../../../../static/icons/list-bullets.svg"
import * as theme from "../../../theme"
import { Typography } from "@material-ui/core"

const BulletList = ({ headline, column, link, pathname }) => {
  return (
    <Container path={pathname}>
      <Info path={pathname}>
        {!!headline && (
          <Headline variant="h2" color="inherit">
            {headline}
          </Headline>
        )}
        {!!link && (
          <StyledButtonLink to={link.url}>{link.title}</StyledButtonLink>
        )}
      </Info>
      <Columns>
        {!!column &&
          column.map((col, index) => {
            return (
              <List key={index} index={index}>
                {!!col &&
                  col.list.map((item, index) => {
                    return (
                      <Item key={index}>
                        <Bullet />
                        <Typography variant="h4">{item.item}</Typography>
                      </Item>
                    )
                  })}
              </List>
            )
          })}
      </Columns>
      {!!link && (
        <Mobile>
          <StyledButtonLink to={link.url}>{link.title}</StyledButtonLink>
        </Mobile>
      )}
    </Container>
  )
}

export default BulletList

const Container = styled(IoAnimator)`
  @media (min-width: 1100px) {
    ${props =>
      props.path === "/" &&
      css`
        margin-left: 6vw;
      `}
  }

  @media (min-width: 1100px) {
    flex-direction: row;
    padding: 60px 40px 30px;
  }

  display: flex;
  flex-direction: column;
  padding: 30px 5% 30px;
`

const Headline = styled(Typography)`
  @media (min-width: 800px) {
    padding-bottom: 60px;
  }
  padding-bottom: 20px;
`

const Item = styled.div`
  @media (min-width: 800px) {
    padding-bottom: 30px;
  }
  padding-bottom: 15px;
  display: flex;
  svg {
    flex-shrink: 0;
    margin-right: 15px;
    margin-top: 2px;
  }
`
const StyledButtonLink = styled(ButtonLink)``
const Mobile = styled.div`
  display: flex;
  @media (min-width: 1100px) {
    ${StyledButtonLink} {
      display: none;
    }
  }
  margin-top: 20px;
`

const Info = styled.div`
  @media (min-width: 1100px) {
    max-width: 50%;
    ${props =>
      props.path === "/" &&
      css`
        max-width: 38%;
      `}
  }
  @media (max-width: 1099px) {
    ${StyledButtonLink} {
      display: none;
    }
  }
  @media (min-width: 800px) {
    padding-right: 45px;
  }

  flex-shrink: 0;
  color: ${theme.color.primary};
`
const List = styled.div`
  width: 100%;
  @media (min-width: 800px) {
    padding: 0 10px;
    &:only-child {
      width: 100%;
    }
    width: 50%;
  }
`
const Columns = styled.div`
  @media (min-width: 800px) {
    flex-direction: row;
    margin-top: 0;
  }
  margin-top: 15px;
  flex-direction: column;
  max-width: 1000px;
  display: flex;
`
